"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAllowedNodesUntil = exports.strategies = exports.SBTypesParsers = exports.STYLABLE_NAMED_MATCHER = exports.STYLABLE_VALUE_MATCHER = exports.stValuesMap = exports.globalValueRegExp = exports.animationPropRegExp = exports.stValues = exports.mixinDeclRegExp = exports.paramMapping = exports.valueMapping = exports.rootValueMapping = exports.valueParserWarnings = void 0;
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
const pseudo_states_1 = require("./pseudo-states");
const selector_1 = require("./helpers/selector");
const value_1 = require("./helpers/value");
exports.valueParserWarnings = {
    VALUE_CANNOT_BE_STRING() {
        return 'value can not be a string (remove quotes?)';
    },
    CSS_MIXIN_FORCE_NAMED_PARAMS() {
        return 'CSS mixins must use named parameters (e.g. "func(name value, [name value, ...])")';
    },
};
exports.rootValueMapping = {
    vars: ':vars',
    import: ':import',
    stScope: 'st-scope',
    namespace: 'namespace',
};
exports.valueMapping = {
    from: '-st-from',
    named: '-st-named',
    default: '-st-default',
    root: '-st-root',
    states: '-st-states',
    extends: '-st-extends',
    mixin: '-st-mixin',
    partialMixin: '-st-partial-mixin',
    global: '-st-global',
};
exports.paramMapping = {
    global: 'st-global',
};
exports.mixinDeclRegExp = new RegExp(`(${exports.valueMapping.mixin})|(${exports.valueMapping.partialMixin})`);
exports.stValues = Object.keys(exports.valueMapping).map((key) => exports.valueMapping[key]);
exports.animationPropRegExp = /animation$|animation-name$/;
exports.globalValueRegExp = new RegExp(`^${exports.paramMapping.global}\\((.*?)\\)$`);
exports.stValuesMap = Object.keys(exports.valueMapping).reduce((acc, key) => {
    acc[exports.valueMapping[key]] = true;
    return acc;
}, {});
exports.STYLABLE_VALUE_MATCHER = /^-st-/;
exports.STYLABLE_NAMED_MATCHER = new RegExp(`^${exports.valueMapping.named}-(.+)`);
exports.SBTypesParsers = {
    '-st-root'(value) {
        return value === 'false' ? false : true;
    },
    '-st-global'(decl, _diagnostics) {
        // Experimental
        const selector = (0, selector_1.parseSelectorWithCache)(decl.value.replace(/^['"]/, '').replace(/['"]$/, ''), { clone: true });
        // ToDo: handle or warn on multiple selectors
        return selector[0].nodes;
    },
    '-st-states'(value, decl, diagnostics) {
        if (!value) {
            return {};
        }
        return (0, pseudo_states_1.processPseudoStates)(value, decl, diagnostics);
    },
    '-st-extends'(value) {
        const ast = (0, postcss_value_parser_1.default)(value);
        const types = [];
        ast.walk((node) => {
            if (node.type === 'function') {
                const args = (0, value_1.getNamedArgs)(node);
                types.push({
                    symbolName: node.value,
                    args,
                });
                return false;
            }
            else if (node.type === 'word') {
                types.push({
                    symbolName: node.value,
                    args: null,
                });
            }
            return undefined;
        }, false);
        return {
            ast,
            types,
        };
    },
    '-st-mixin'(mixinNode, strategy, diagnostics, emitStrategyDiagnostics = true) {
        const ast = (0, postcss_value_parser_1.default)(mixinNode.value);
        const mixins = [];
        function reportWarning(message, options) {
            if (emitStrategyDiagnostics) {
                diagnostics === null || diagnostics === void 0 ? void 0 : diagnostics.warn(mixinNode, message, options);
            }
        }
        ast.nodes.forEach((node) => {
            if (node.type === 'function') {
                mixins.push({
                    type: node.value,
                    options: exports.strategies[strategy(node.value)](node, reportWarning),
                    valueNode: node,
                    originDecl: mixinNode,
                });
            }
            else if (node.type === 'word') {
                mixins.push({
                    type: node.value,
                    options: strategy(node.value) === 'named' ? {} : [],
                    valueNode: node,
                    originDecl: mixinNode,
                });
            }
            else if (node.type === 'string') {
                diagnostics === null || diagnostics === void 0 ? void 0 : diagnostics.error(mixinNode, exports.valueParserWarnings.VALUE_CANNOT_BE_STRING(), {
                    word: mixinNode.value,
                });
            }
        });
        return mixins;
    },
    '-st-partial-mixin'(mixinNode, strategy, diagnostics) {
        return exports.SBTypesParsers['-st-mixin'](mixinNode, strategy, diagnostics).map((mixin) => {
            mixin.partial = true;
            return mixin;
        });
    },
};
exports.strategies = {
    named: (node, reportWarning) => {
        const named = {};
        (0, value_1.getNamedArgs)(node).forEach((mixinArgsGroup) => {
            const argsDivider = mixinArgsGroup[1];
            if (mixinArgsGroup.length < 3 || (argsDivider && argsDivider.type !== 'space')) {
                if (reportWarning) {
                    const argValue = mixinArgsGroup[0];
                    reportWarning(exports.valueParserWarnings.CSS_MIXIN_FORCE_NAMED_PARAMS(), {
                        word: argValue.value,
                    });
                }
                return;
            }
            named[mixinArgsGroup[0].value] = stringifyParam(mixinArgsGroup.slice(2));
        });
        return named;
    },
    args: (node, reportWarning) => {
        return (0, value_1.getFormatterArgs)(node, true, reportWarning).map((value) => ({ value }));
    },
};
function stringifyParam(nodes) {
    return postcss_value_parser_1.default.stringify(nodes, (n) => {
        if (n.type === 'function') {
            return postcss_value_parser_1.default.stringify(n);
        }
        else if (n.type === 'div') {
            return null;
        }
        else if (n.type === 'string') {
            return n.value;
        }
        else {
            return undefined;
        }
    });
}
function validateAllowedNodesUntil(node, i, untilType = 'div', allowed = ['comment']) {
    i = 1;
    let current = node.nodes[i];
    while (current && current.type !== untilType) {
        if (!allowed.includes(current.type)) {
            return false;
        }
        i++;
        current = node.nodes[i];
    }
    return true;
}
exports.validateAllowedNodesUntil = validateAllowedNodesUntil;
//# sourceMappingURL=stylable-value-parsers.js.map